import type { DrawerSide } from "./drawer.types";

/** Base classes applied to all drawer panels. */
export const drawerBaseClass = "fixed z-[52] bg-(--color-background) flex flex-col";

/** Overlay behind the drawer panel — subtle blur to push focus onto the drawer. */
export const drawerOverlayClass = "fixed inset-0 z-[51] bg-black/10 backdrop-blur-xs";

/** Side-specific positioning and inner border classes. */
export const drawerSideClasses: Record<DrawerSide, string> = {
  top: "top-0 left-0 right-0 border-b border-(--color-border)",
  right: "top-0 right-0 bottom-0 border-l border-(--color-border)",
  bottom: "bottom-0 left-0 right-0 border-t border-(--color-border)",
  left: "top-0 left-0 bottom-0 border-r border-(--color-border)",
};

/** Absolutely positioned wrapper for the drag handle at the inner edge of a resizable drawer. */
export const drawerResizableHandleClasses: Record<DrawerSide, string> = {
  right: "absolute top-0 left-0 bottom-0 w-2 cursor-col-resize z-10",
  left: "absolute top-0 right-0 bottom-0 w-2 cursor-col-resize z-10",
  top: "absolute left-0 right-0 bottom-0 h-2 cursor-row-resize z-10",
  bottom: "absolute left-0 right-0 top-0 h-2 cursor-row-resize z-10",
};

/** Header region — title slot + close button, pinned at the top. */
export const drawerHeaderClass =
  "grid shrink-0 grid-cols-[1fr_auto] items-start gap-3 border-b border-(--color-border) px-5 py-4";

/** Optional leading slot region — sits below the header, above the body. */
export const drawerLeadingClass = "shrink-0 border-b border-(--color-border)";

/** Main scrollable body region. */
export const drawerBodyClass = "min-h-0 flex-1 overflow-auto";

/** Optional trailing slot region — sits above the footer. */
export const drawerTrailingClass = "shrink-0 border-t border-(--color-border)";

/** Optional footer slot region — pinned at the bottom. */
export const drawerFooterClass = "shrink-0 border-t border-(--color-border)";
